import { Tag } from "@vp/models";
import { MultiTagSelectorStateModel } from "../model/multi-tag-selector-state.model";

export class UpdateState {
  public static readonly type = "[Multi Tag Selector] Update State";
  constructor(public state: Partial<MultiTagSelectorStateModel>) {}
}

export class AddSelectedTags {
  public static readonly type = "[Multi Tag Selector] Add Selected Tags";
  constructor(public tagsToAdd: Tag[]) {}
}

export class RemoveSelectedTags {
  public static readonly type = "[Multi Tag Selector] Remove Selected Tags";
  constructor(public tagsToRemove: Tag[]) {}
}
